// Trạng thái khảo sát (surveys.status): app chỉ hiện khảo sát đã duyệt.
export const SURVEY_APPROVAL = {
  APPROVED: 1,
  PENDING: 0,
};

export const SURVEY_APPROVAL_OPTIONS = [
  { label: 'Chờ duyệt', value: SURVEY_APPROVAL.PENDING },
  { label: 'Đã duyệt', value: SURVEY_APPROVAL.APPROVED },
];

// Trạng thái câu hỏi / lựa chọn (questions.status, options.status).
// API CMS coi status = 0 là đã xoá (không trả về), nên câu đã "Khóa" sẽ không hiện lại trong form.
export const SURVEY_STATUS = {
  ACTIVE: 1,
  LOCKED: 0,
};

export const STATUS_OPTIONS = [
  { label: 'Hoạt động', value: SURVEY_STATUS.ACTIVE },
  { label: 'Khóa', value: SURVEY_STATUS.LOCKED },
];

export const QUESTION_TYPES = {
  RATING_FEEDBACK: 1, // Đánh giá & Góp ý (rating)
  SINGLE_CHOICE: 2,   // Trắc nghiệm (1 đáp án)
  MULTIPLE_CHOICE: 3, // Trắc nghiệm (nhiều đáp án)
  TEXTAREA: 4,        // Văn bản (Tự luận)
  LIKERT: 5,          // Thang đo Likert (Mức độ)
  MULTI_CRITERIA: 6,  // Đánh giá nhiều tiêu chí (ranking)
  SLIDER: 7,          // Thanh trượt (Số) (scale_bar)
};

export const QUESTION_TYPE_OPTIONS = [
  { label: 'Đánh giá & Góp ý (Rating)', value: QUESTION_TYPES.RATING_FEEDBACK },
  { label: 'Trắc nghiệm (1 đáp án)', value: QUESTION_TYPES.SINGLE_CHOICE },
  { label: 'Trắc nghiệm (Nhiều đáp án)', value: QUESTION_TYPES.MULTIPLE_CHOICE },
  { label: 'Văn bản (Tự luận)', value: QUESTION_TYPES.TEXTAREA },
  { label: 'Thang đo Likert (Mức độ)', value: QUESTION_TYPES.LIKERT },
  { label: 'Đánh giá nhiều tiêu chí (Ranking)', value: QUESTION_TYPES.MULTI_CRITERIA },
  { label: 'Thanh trượt (Số / Scale bar)', value: QUESTION_TYPES.SLIDER },
];

export const OPTION_TYPES = {
  TEXT: 1,
  IMAGE: 2,
  LINK: 3,
  FILE: 4,
};

export const OPTION_TYPE_OPTIONS = [
  { label: 'Văn bản (Text)', value: OPTION_TYPES.TEXT },
  { label: 'Hình ảnh (Image)', value: OPTION_TYPES.IMAGE },
  { label: 'Đường dẫn (Link)', value: OPTION_TYPES.LINK },
  { label: 'Tệp tin (File)', value: OPTION_TYPES.FILE },
];

export const INPUT_TYPES = {
  NONE: 0,
  TEXT: 1,
  LINK: 2,
  IMAGE: 3,
  FILE: 4,
};

export const INPUT_TYPE_OPTIONS = [
  { label: 'Không có ô nhập (None)', value: INPUT_TYPES.NONE },
  { label: 'Nhập văn bản (Text)', value: INPUT_TYPES.TEXT },
  { label: 'Nhập đường dẫn (Link)', value: INPUT_TYPES.LINK },
  { label: 'Tải ảnh lên (Image)', value: INPUT_TYPES.IMAGE },
  { label: 'Tải tệp tin (File)', value: INPUT_TYPES.FILE },
];

export const REQUIRED_OPTIONS = [
  { label: 'Bắt buộc (Có)', value: 1 },
  { label: 'Không bắt buộc', value: 0 },
];

// Trạng thái xử lý góp ý (feedbacks.status)
export const FEEDBACK_STATUS = {
  NEW: 0,
  PROCESSING: 1,
  DONE: 2,
};

export const FEEDBACK_STATUS_OPTIONS = [
  { label: 'Mới', value: FEEDBACK_STATUS.NEW, color: 'blue' },
  { label: 'Đang xử lý', value: FEEDBACK_STATUS.PROCESSING, color: 'orange' },
  { label: 'Đã xử lý', value: FEEDBACK_STATUS.DONE, color: 'green' },
];
